/* SessionStatusIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIey7F%7Bmin-width%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Spinner from '@atlaskit/spinner/spinner';
import { messages } from './messages';
import { SessionStatusBadge } from './SessionStatusBadge';
import { SessionStatusIcon } from './SessionStatusIcon';
import { SessionUnreadIndicator } from './SessionUnreadIndicator';
const styles = {
  indicator: "_4ouGXIey7F _3YEZNOdnbC"
};
export type SessionStatusIndicatorProps = {
  /** Presentation status selected by the owning session component. */
  status?: 'working' | 'needs-input' | 'unread';
  /** Controls whether needs input uses the full badge or its compact icon treatment. */
  requiresInputAppearance?: 'badge' | 'icon';
  testId?: string;
};

/** Renders the selected session status indicator. */
export const SessionStatusIndicator = ({
  status,
  requiresInputAppearance = 'badge',
  testId
}: SessionStatusIndicatorProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const indicator = status === 'working' ? <Spinner size="small" label={formatMessage(messages.inProgress)} /> : status === 'needs-input' ? requiresInputAppearance === 'icon' ? <SessionStatusIcon status="needs-input" iconSize={16} color={"var(--ds-icon-accent-blue, #357DE8)"} label={formatMessage(messages.needsInput)} testId="session-status-icon" /> : <SessionStatusBadge status="needs-input" iconSize={16} /> : status === 'unread' ? <SessionUnreadIndicator /> : null;
  return indicator ? <Inline as="span" alignBlock="center" alignInline="center" xcss={styles.indicator} testId={testId}>
			{indicator}
		</Inline> : null;
};